import { convexQuery } from '@convex-dev/react-query'
import { api } from '@cvx/_generated/api'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { TeamSettingsPage } from '@/features/settings/components/team-settings-page'

export const Route = createFileRoute(
  '/_app/_auth/dashboard/_layout/settings/team',
)({
  component: TeamSettingsRoute,
  beforeLoad: async () => {
    return {
      title: 'Team',
      headerTitleKey: 'header.team.title',
      headerDescriptionKey: 'header.team.description',
    }
  },
})

function TeamSettingsRoute() {
  const { data: user } = useQuery(
    convexQuery(api.features.user.user.getMyCurrentUser, {}),
  )

  if (!user) return null

  return <TeamSettingsPage user={user} />
}
